var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-card',[_c('el-row',[_vm._t("header",null,{"currentProgress":this.myProgress,"currentText":this.myText})],2),_c('el-divider'),_c('div',{staticClass:"block"},[(_vm.donation)?_c('BloodDonationTimeline',{attrs:{"donation":_vm.donation},on:{"action":_vm.btnAction}}):_vm._e()],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }